import React from "react";

const Heromainsec = () => {
  return (
    <div className="hero-main-sec-container" data-aos="fade-right">
      <div className="hero-text-box">
        <div className="combine-text">
          <div className="hero-title">HealthGate.</div>
          <div className="hero-desc">Your one stop access to all resources</div>
        </div>
      </div>

      <div className="hero-only-img">
        <img src="./Images/poster3.png" alt="poster" className="poster1" />
      </div>
    </div>
  );
};

export default Heromainsec;
